import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";

const BannerQuick = () => {
  const [name, setName] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [phone, setPhone] = useState<string>("");

  const handlerPostContact = async () => {
    if (!name || !address || !phone) {
      Swal.fire({
        title: "기본 정보를 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    // setLoading(true);

    await axios
      .post("/api/contact/quick", {
        name: name,
        phone: phone,
        address: address,
        type: "배너",
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.result === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        // setLoading(false);
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };
  return (
    <aside className="lg:col-span-2 relative w-full h-full lg:pr-4 z-10">
      <div className="bg-white px-8 py-5 relative w-full h-full">
        {/* 로고 영역 */}
        <div className="mb-4 relative w-full h-fit">
          <img
            alt="누수 상담 문의 안내"
            className="!relative w-full h-full max-h-24 py-1 object-contain"
            src="/images/bannerContactTitle.png"
            width={835}
            height={155}
          />
        </div>

        {/* 입력 영역 */}
        <div className="grid grid-cols-2 gap-2 xl:gap-4">
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="이름을 입력하세요"
            className="h-12 xl:h-14 rounded-md bg-gray-100 px-3 text-center text-base xl:text-xl outline-none focus:ring-2 focus:ring-primary placeholder:text-font"
          />

          <input
            value={phone}
            onChange={(e) => setPhone(e.target.value.replace(/[^0-9]/g, ""))}
            placeholder="연락처를 입력하세요"
            inputMode="numeric"
            maxLength={11}
            className="h-12 xl:h-14 rounded-md bg-gray-100 px-3 text-center text-base xl:text-xl outline-none focus:ring-2 focus:ring-primary placeholder:text-font"
          />

          <input
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            placeholder="주소를 입력하세요"
            className="col-span-2 h-12 xl:h-14 rounded-md bg-gray-100 px-3 text-center text-base xl:text-xl outline-none focus:ring-2 focus:ring-primary placeholder:text-font"
          />
        </div>

        {/* 개인정보 동의 */}
        <label className="mt-2 flex cursor-pointer items-center gap-2 text-sm">
          <input
            type="checkbox"
            name="privacy"
            id="privacy"
            defaultChecked
            checked={true}
            className="!w-3 !h-3 mb-1"
          />
          개인정보 처리방침 동의
        </label>

        {/* 버튼 */}
        <button
          type="button"
          onClick={handlerPostContact}
          className="mt-3 xl:mt-5 w-full rounded-md bg-point py-2 text-3xl text-primary transition hover:bg-yellow-200"
        >
          전송하기
          <span className="block text-base font-light text-font">
            &#40; 문의 후 최대 10분안에 연락드립니다 &#41;
          </span>
        </button>
      </div>
    </aside>
  );
};

export default BannerQuick;
